<script lang="jsx">
import Success from '@/plans/ZOOM_ONE_BUNDLE/success.vue';

import { planTypes } from '@/common/constants';

export default {
  name: 'ZEduPlus',
  extends: Success,
  data() {
    return {
      planType: planTypes.ZONE_PRO_PLUS,
    };
  },
  computed: {
    isSetupZP() {
      return false;
    },
  }
};
</script>
